import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.utiliti.ng";

// Create axios instance with authentication
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for authentication
axiosInstance.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem('user');
    let token = '';
    if (user) {
      try {
        token = JSON.parse(user).token;
      } catch (e) { }
    }
    if (token) {
      config.headers['x-auth-token'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

const spinService = {
  // Prize Management
  getAllPrizes: async () => {
    try {
      const response = await axiosInstance.get('/api/spin/admin/prizes');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getPrizeById: async (id) => {
    try {
      const response = await axiosInstance.get(`/api/spin/admin/prizes/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  createPrize: async (prizeData) => {
    try {
      const response = await axiosInstance.post('/api/spin/admin/prizes', prizeData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  updatePrize: async (id, prizeData) => {
    try {
      const response = await axiosInstance.put(`/api/spin/admin/prizes/${id}`, prizeData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  deletePrize: async (id) => {
    try {
      const response = await axiosInstance.delete(`/api/spin/admin/prizes/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Configuration
  getConfig: async () => {
    try {
      const response = await axiosInstance.get('/api/spin/admin/config');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  updateConfig: async (configData) => {
    try {
      const response = await axiosInstance.put('/api/spin/admin/config', configData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Preselected Winners
  getPreselectedWinners: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/api/spin/admin/preselected-winners', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  createPreselectedWinner: async (winnerData) => {
    try {
      const response = await axiosInstance.post('/api/spin/admin/preselected-winners', winnerData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  bulkCreatePreselectedWinners: async (winnersData) => {
    try {
      const response = await axiosInstance.post('/api/spin/admin/preselected-winners/bulk', winnersData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  deletePreselectedWinner: async (id) => {
    try {
      const response = await axiosInstance.delete(`/api/spin/admin/preselected-winners/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Statistics
  getAllSpins: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/api/spin/admin/spins', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getSpinStatistics: async () => {
    try {
      const response = await axiosInstance.get('/api/spin/admin/statistics');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Spin Actions
  claimSpin: async (id) => {
    try {
      const response = await axiosInstance.post(`/api/spin/admin/spins/${id}/claim`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  cancelSpin: async (id) => {
    try {
      const response = await axiosInstance.post(`/api/spin/admin/spins/${id}/cancel`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default spinService;

